import * as React from 'react';

const SvgColumnRight = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="3"
      y="8.5"
      width="7"
      height="7"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      opacity="0.12"
      x="14"
      y="3"
      width="7"
      height="18"
      rx="2"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="14"
      y="3"
      width="7"
      height="18"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);

export default SvgColumnRight;
